import {UserCreationRolesProvider} from '@hconnect/adminconsole/src/contexts/UserCreationRolesContext'
import {CreateUser} from '@hconnect/adminconsole/src/pages/CreateUser/CreateUser'
import {User} from '@hconnect/apiclient'
import {PermissionTypes} from '@hconnect/uikit'
import {useSelector} from 'react-redux'

import {withRouteRequiringPermission} from '../../Molecules/PermissionBoundary'
import {usePermissions} from '../../Permissions'
import {AppState} from '../../Root.store'

const CreateUserPage = () => {
  const {adminConsoleGrantedPermissionTypes} = usePermissions()
  const loggedInUserProfile = useSelector<AppState, User | null>(
    (state) => state.userProfile.userProfile
  )
  return (
    <UserCreationRolesProvider>
      <CreateUser
        loggedInUserProfile={loggedInUserProfile}
        loggedInUserPermissions={adminConsoleGrantedPermissionTypes}
      />
    </UserCreationRolesProvider>
  )
}

export const ROUTE = '/createUser'
export default withRouteRequiringPermission({
  path: ROUTE,
  label: 'Create User',
  hideInMainNav: true,
  routeProps: {exact: true},
  permissions: [PermissionTypes.VIEW_USERS, PermissionTypes.CHANGE_USERS]
})(CreateUserPage)
